import { Info } from "lucide-react";
import { cn } from "@/lib/utils";
import { useI18n } from "@/lib/i18n";

export function TravelFeeNote({ className }: { className?: string }) {
  const { t } = useI18n();
  return (
    <div
      role="note"
      aria-label={t("travelFee.aria")}
      className={cn(
        "flex items-start gap-2.5 rounded-md border border-accent/30 bg-accent/5 px-4 py-3 text-xs text-muted-foreground",
        className,
      )}
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden />
      <p className="leading-relaxed">
        <span className="font-semibold text-primary">{t("travelFee.amount")}</span>{" "}
        {t("travelFee.text")}
      </p>
    </div>
  );
}
